module.exports = __webpack_public_path__ + "img/Marketplace.3a0154e5.svg";